module.exports = __webpack_public_path__ + "img/awards.c1230118.jpg";